import React from "react";
import _ from "lodash";
import ProductCardComponent from "../ProductCard/ProductCardComponent";
import ListingFilterSectionComponent from "../ListingContent/ListingFilterSection/ListingFilterSectionComponent";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllCoaching,
  getAllCoachingClear,
} from "../../../redux/coaching/actions";
import {
  FreeForYou,
  FreePaidSubscription,
  SessionKeys,
  convertTimeInHourAndMin,
  getPriceInfoForEntity,
  PriceInfo,
  getProcureInfo,
  ProductCardPriceInfo,
} from "../../../utils/AppUtils";
import Loader from "../../Loader/Loader";
import {
  providerCoachingClear,
  providerList,
  providerListClear,
} from "../../../redux/provider/actions";
import CONFIG from "../../../utils/config";
import EventSliderFilterSection from "../Event/EventSliderFilter";
import { providerCoaching } from "../../../redux/provider/actions";
import ErrorSection from "../../ErrorPage/ErrorSection";
import "./CoachingListSection.scss";

function CoachingListSection() {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const c = params.get("c");
  let provider_id = "";
  let provider_name = "";
  if (c) {
    let decodedString = atob(c);
    let paramsReq = JSON.parse(decodedString);
    provider_id = paramsReq.provider_id;
    provider_name = paramsReq.provider_name;
  }
  // const provider_id = paramsReq.provider_id;
  // const provider_id = params.get("provider_id");
  // const [providerId, setProviderId ] = useState(provider_id);
  const [eventList, setEventList] = useState([]);
  const eventsListRes = useSelector((state) => state.coaching.coachingDataList);
  // const providersDataResponse = useSelector((state) => state.provider.providersDataListRes);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [eventCount, setEventCount] = useState(0);
  const dispatch = useDispatch();
  const [apiListing, setAPIListing] = useState([]);
  const [listing, setListing] = useState([]);
  const navigate = useNavigate();
  const [providerListing, setProviderListing] = useState([]);
  const [isProviderLoading, setIsProviderLoading] = useState(false);

  const isPremiumUser = useSelector((state) => state.user.isPremiumUser);
  const navigateToView = (data) => {
    let paramsReq = {
      service_code: data?.service_code,
      provider_name: provider_name,
      provider_id: provider_id,
      service_id: data?.product_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/coaching-detail?c=${encodedUrl}`;
    navigate(url);
  };

  const [selectedSort, setSelectedSort] = useState(3);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [sortOption] = useState([
    { value: 1, label: "Name (A to Z)" },
    { value: 2, label: "Name (Z to A)" },
    { value: 3, label: 'New To Old' },
    { value: 4, label: 'Old To New' }
  ]);
  const [filterOption] = useState([
    { value: 1, label: "All" },
    // { value: 2, label: "Available for Purchase" },
    { value: 3, label: "Purchased Services" },
  ]);

  useEffect(() => {
    // provider_list();
    // all_provider_coaching();
    provider_coaching();
  }, [selectedSort]);

  const onSearchClicked = (searchText) => {
    console.log("searchText", searchText);
    setproviderCoachingData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    if (searchText) {
      const searchStr = searchText.toLowerCase();
      setproviderCoachingData(
        originalCoachingData.filter((item) => {
          console.log("item--", item);
          const title = item.title.toLowerCase();
          const tags = item.tagsArray.map((t) => t.toLowerCase());
          if (title.includes(searchStr)) {
            return item;
          } else if (!_.isEmpty(tags)) {
            for (let t of tags) {
              if (t.includes(searchStr)) {
                return item;
              }
            }
          }
        })
      );
    } else {
      setproviderCoachingData(originalCoachingData);
    }
  };

  const formatDataForProductCard = (coachingData) => {
    console.log("coachingData", coachingData);
    setproviderCoachingData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    let eventArr = [];
    for (let item of coachingData) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      logoURL = item.provider.provider_img;
      // for (let i of item.menu_data) {
      //     tags.push(i);
      // }
      tags.push(item.provider.provider_display_name);
      tags.push("Services"); //item.service_type
      tags.push(
        _.toLower(item?.payment_frequency) === "monthly"
          ? "Subscription"
          : "One Time"
      );
      let priceInfo = getProcureInfo(item.purchased_info);
      let footerComp = "";
      eventArr.push({
        id: item?.product_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        is_wishlist: item?.is_addtowishlist,
        dbId: item?.list_id,
        is_coaching: true,
        show_subscription:  _.toLower(item?.payment_frequency) === "monthly" ? true :false,
        productType: item?.service_type,
        productOrigin: item?.source,
        title: item.product_name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item.product_thumbnail,
        tagsArray: tags,
        description: item.summary ? item.summary : "",
        duration: convertTimeInHourAndMin(item.duration ? item.duration : 0),
        showHeader: true,
        showPlayButton: false,
        showProviderIcon: true,
        showLikeMenu: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        btnAction: () => navigateToView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToView(item),
        cardClassName: "",
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        priceInfo,
        updatedAt:_.isEmpty(priceInfo)|| !priceInfo.isPurchased ?item?.created_dt:"",
      });
    }
    console.log("event array", eventArr);
    setproviderCoachingData(eventArr);
    setOriginalCoachingData(eventArr);
    // setOriginalEventList(eventArr);
    // setEventCount(eventArr.length);
    // setAPIListing(eventArr)
  };

  const onFilterClicked = (filterValue) => {
    // setVideoListing(apiVideoListing.filter(video => {
    //     if (filterValue === 2) {
    //         return video.priceInfo.price > 0 && !video.priceInfo.isPaid
    //     } else if (filterValue === 3) {
    //         return video.priceInfo.isPaid
    //     } else {
    //         return video
    //     }
    // }))
  };

  const [search_input, setsearch_input] = useState("");
  const [allCoaching, setallCoaching] = useState(false);
  const [providerCoachingData, setproviderCoachingData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );
  const [originalCoachingData, setOriginalCoachingData] = useState();

  const [selectedPartner, setSelectedPartner] = useState(
    provider_id ? "" : "all"
  );

  useEffect(() => {
    console.log("pcdata", providerCoachingData);
    return () => {};
  }, [providerCoachingData]);

  useEffect(() => {
    provider_coaching();
    return () => {
      dispatch(providerListClear());
      dispatch(providerCoachingClear());
    };
  }, []);
  useEffect(() => {
    console.log("sel--", selectedPartner);
    provider_coaching();
    return () => {
      dispatch(providerCoachingClear());
    };
  }, [selectedPartner]);

  const provider_coaching = () => {
    setproviderCoachingData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    setallCoaching(false);
    dispatch(
      providerCoaching({
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          provider_id:
            selectedPartner === "all"
              ? ""
              : selectedPartner || provider_id || "",
          type: "coaching",
          search: search_input,
          sort_by: selectedSort,
        },
      })
    );
  };

  const all_provider_coaching = () => {
    setproviderCoachingData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    setallCoaching(true);

    dispatch(
      providerCoaching({
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "coaching",
          search: search_input,
          sort_by:
            selectedSort === 1 ? "ASC" : selectedSort === 2 ? "DESC" : selectedSort,
        },
      })
    );
  };

  const providerCoachingResponse = useSelector(
    (state) => state.provider.providerCoachingResponse
  );
  console.log("provider coaching response", providerCoachingResponse);

  useEffect(() => {
    if (!_.isEmpty(providerCoachingResponse)) {
      if (providerCoachingResponse.status === "success") {
        const listData = providerCoachingResponse?.payload?.data?.data?.List;
        for (let data of listData) {
          data.is_recurring = false;
          if (data.payment_frequency !== "One time") {
            data.is_recurring = true;
          }
        }
        console.log("List", listData);
        formatDataForProductCard(listData);
        //setproviderCoachingData(listData);
        setIsLoading(false);
      } else {
        setproviderCoachingData(null);
        setIsLoading(false);
      }
    }
  }, [providerCoachingResponse]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="contsection">
        <div className="tab-content" id="nav-tabContent">
          <ListingFilterSectionComponent
            onSearchClicked={onSearchClicked}
            showSearch={true}
            showSort={true}
            showFilter={false}
            showCategories={false}
            sortOption={sortOption}
            filterOption={filterOption}
            sortSelected={selectedSort}
            searchPlaceHolder={"Search for services..."}
            setSelectedSort={setSelectedSort}
            setSelectedFilter={(value) => {
              setSelectedFilter(value);
              onFilterClicked(value);
            }}
            entityType={"coaching"}
          />
        </div>
        {provider_id ? (
          ""
        ) : (
          <EventSliderFilterSection
            selectedPartner={selectedPartner}
            setSelectedPartner={setSelectedPartner}
          />
        )}
        <div className="">
          {isFetching ? (
            ""
          ) : (
            <span>
              We found {eventCount} Services{eventCount > 1 ? "s" : ""} for you
            </span>
          )}
          <div className="coursecard-row row">
            {_.isEmpty(providerCoachingData) ? (
              <ErrorSection  btnTitle={"Explore Courses"}
              btnAction={"/learn/courses?tab=1"}/>
            ) : (
              providerCoachingData.map((item, index) => {
                return (
                  <>
                    <ProductCardComponent
                      {...item}
                      key={`event-${index + 1}`}
                      cardClassName="coachingcard"
                    />
                  </>
                );
              })
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default CoachingListSection;
